import { Directive, HostListener, Input, Renderer2, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberWithCommas]',
})
export class NumberWithCommasDirective {
  @Input() locale: string = 'en-US'; // Default locale


  constructor(
    private control: NgControl,
    private el: ElementRef,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) { }
  
  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // Remove commas for raw numeric processing
    const rawValue = value.replace(/,/g, '');
    const numericValue = parseFloat(rawValue);

    // Update the form control with the raw numeric value
    if (!isNaN(numericValue)) {
      this.control.control?.setValue(numericValue);
    } else {
      this.control.control?.setValue(null);
    }

    // Set the display value with formatting
    this.renderer.setProperty(this.el.nativeElement, 'value', this.formatNumber(numericValue));
  }

  @HostListener('blur') onBlur(): void {
    // Format the value when input loses focus
    const value = this.control.control?.value;
    if (value !== null && value !== undefined) {
      this.renderer.setProperty(this.el.nativeElement, 'value', this.formatNumber(value));
    }
  }

  @HostListener('focus') onFocus(): void {
    // Show the raw numeric value when input gains focus
    const value = this.control.control?.value;
    if (value !== null && value !== undefined) {
      this.renderer.setProperty(this.el.nativeElement, 'value', this.formatNumber(value));
    }
  }
  private applyFormatting() {
    const value = this.control.control?.value;
    if (value !== null && value !== undefined) {
      this.renderer.setProperty(this.el.nativeElement, 'value', this.formatNumber(value));
    }
  }
  private formatNumber(value: number | null): string {
    return value !== null && !isNaN(value) ? value.toLocaleString(this.locale) : '';
  }
}
